import util from '@bmp-vue/core/api/util'
import downloadUtil from '../downloadUtil'

const controller = 'OperacaoVisaArquivoConsolidacao';

export default Object.assign({}, util.GetCrud(controller, null), {
  GetRelatoriosConsolidacaoOperacaoVisa(dto) {
    return util.Axios.GetAll(controller, dto);
  },
  GetArquivoConsolidacaoFromS3(diretorio) {

    const filename = diretorio.split('/')[2] + ".zip";

    // Remove o nome do arquivo do diretorio
    diretorio = diretorio.split('/').slice(0, 2).join('/');

    return downloadUtil.Axios.DownloadZipFile(
      controller + "/Download",
      {
        diretorio,
        filename
      },
      filename
    );
  }
});
